import Vue from 'vue'

const eventBus = new Vue(
  {
    data () {
      return {
        filesDataByGuidDefault: {}
      }
    }
  }
)

export default eventBus
